import { render, staticRenderFns } from "./InsideCard.vue?vue&type=template&id=1ce210c4&scoped=true&"
import script from "./InsideCard.vue?vue&type=script&lang=js&"
export * from "./InsideCard.vue?vue&type=script&lang=js&"
import style0 from "./InsideCard.vue?vue&type=style&index=0&id=1ce210c4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce210c4",
  null
  
)

export default component.exports